/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';


export interface ResourcePoolAssignWithOrgIdSpec { 
    provider_type: ResourcePoolProviderType;
    preferred_resource_id?: string;
    /**
     * Reconfigure IRR.
     */
    reconfigure_irr?: boolean;
    /**
     * Org id
     */
    org_id: string;
}
export namespace ResourcePoolAssignWithOrgIdSpec {
}


